class RefreshData {
  constructor(
    Authentication,
    IgnoreServerErrors,
    StatusService,
    PersonaCollection,
    NewsfeedCollection,
    TaskCollection,
    EventCollection,
    NotificationCollection,
    Socket,
    $rootScope,
    $q
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      IgnoreServerErrors,
      PersonaCollection,
      Socket,
      $rootScope,
      $q,
    });

    this.services = [PersonaCollection, NewsfeedCollection, TaskCollection, NotificationCollection];
  }

  setDataDirty() {
    this.services.forEach((service) => service.setDirty());
  }
}

export default RefreshData;
